import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './block-info.scss';

export class BlockInfo extends PureComponent {
  render() {
    const { title, text } = this.props.content;

    return (
      <div className="block-info">
        {(!!title) &&
          <h4 dangerouslySetInnerHTML={{ __html: title}} />
        }
        {(!!text) &&
          <p dangerouslySetInnerHTML={{ __html: text }} />
        }
      </div>
    );
  }
}

BlockInfo.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string
  })
};

export default BlockInfo;



// WEBPACK FOOTER //
// ./src/components/widgets/Typography/BlockInfo.js